import Swiper, { Navigation } from 'swiper';

$(document).ready(function () {
  Swiper.use([Navigation]);

  const featuresSlider = new Swiper('.js-features-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: ".js-features-slider-next",
      prevEl: ".js-features-slider-prev",
    },
  });
});



// WEBPACK FOOTER //
// ./src/js/pages/main/features-slider.js